import { render, staticRenderFns } from "./FeedingRecordAdd.vue?vue&type=template&id=19852332&scoped=true"
import script from "./FeedingRecordAdd.vue?vue&type=script&lang=js"
export * from "./FeedingRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./FeedingRecordAdd.vue?vue&type=style&index=0&id=19852332&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19852332",
  null
  
)

export default component.exports